import { Permissions } from '@utils/constants/permissions';

import { store } from 'store/store';

export const isHouseCompactParam = () =>
  store?.getState()?.userReducer?.user?.role?.permissions?.some(p => {
    if (
      p === Permissions.PERMISSION_READ_FLATS ||
      p === Permissions.PERMISSION_READ_BOOKINGS ||
      p === Permissions.PERMISSION_READ_CONTRACTS ||
      p === Permissions.PERMISSION_READ_DEBTS
    )
      return true;
    return false;
  });
